const FOCUSABLE_SELECTOR = 'a, button, input, select, textarea, [tabindex]';
const STORED_TABINDEX = 'data-lifted-tabindex';

export function slidesPerViewValue(value, fallback) {
    if (value === undefined || value === null || value === '') {
        return fallback;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
}

function suppressFocusable(el) {
    if (!el.hasAttribute(STORED_TABINDEX)) {
        el.setAttribute(STORED_TABINDEX, el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
    }

    el.setAttribute('tabindex', '-1');
}

function restoreFocusable(el) {
    if (!el.hasAttribute(STORED_TABINDEX)) {
        return;
    }

    const previous = el.getAttribute(STORED_TABINDEX);
    if (previous === '') {
        el.removeAttribute('tabindex');
    } else {
        el.setAttribute('tabindex', previous);
    }

    el.removeAttribute(STORED_TABINDEX);
}

export function updateSlideAccessibility(swiper) {
    if (!swiper || !swiper.slides) {
        return;
    }

    const visibleSlides = swiper.visibleSlides && swiper.visibleSlides.length
        ? new Set(swiper.visibleSlides)
        : new Set([swiper.slides[swiper.activeIndex]].filter(Boolean));

    const focusedEl = document.activeElement;
    let focusMoved = false;

    swiper.slides.forEach((slideEl) => {
        const isVisible = visibleSlides.has(slideEl)
            || slideEl.classList.contains('swiper-slide-visible')
            || slideEl.classList.contains('swiper-slide-active');

        slideEl.removeAttribute('inert');

        if (isVisible) {
            slideEl.removeAttribute('aria-hidden');
            slideEl.querySelectorAll(FOCUSABLE_SELECTOR).forEach(restoreFocusable);
            return;
        }

        if (!focusMoved && focusedEl && slideEl.contains(focusedEl)) {
            const nextEl = swiper.navigation && swiper.navigation.nextEl;
            const focusTarget = Array.isArray(nextEl) ? nextEl[0] : nextEl;
            if (focusTarget && typeof focusTarget.focus === 'function' && !focusTarget.disabled) {
                focusTarget.focus();
            } else if (typeof focusedEl.blur === 'function') {
                focusedEl.blur();
            }
            focusMoved = true;
        }

        slideEl.setAttribute('aria-hidden', 'true');
        slideEl.querySelectorAll(FOCUSABLE_SELECTOR).forEach(suppressFocusable);
    });
}

export function bindSlideAccessibility(swiper) {
    if (!swiper) {
        return;
    }

    const update = () => updateSlideAccessibility(swiper);
    update();
    swiper.on('activeIndexChange', update);
    swiper.on('slideChangeTransitionEnd', update);
    swiper.on('resize', update);
}
